import React from 'react';
import MediaSearchInput from './MediaSearchInput';
import MediaFilters from './MediaFilters';
import MediaGrid from './MediaGrid';

export default function MediaPickerModal({
  open,
  query,
  type,
  orientation,
  items,
  loading,
  error,
  selectedItem,
  hasMore,
  onSearch,
  onTypeChange,
  onOrientationChange,
  onSelect,
  onLoadMore,
  onCancel,
  onApply,
}) {
  if (!open) return null;

  return (
    <div className="mp-media-picker-modal" role="dialog" aria-modal="true" aria-label="Selecionar mídia">
      <div className="mp-media-picker-modal__header">
        <MediaSearchInput value={query} onSearch={onSearch} />
        <MediaFilters
          type={type}
          orientation={orientation}
          onTypeChange={onTypeChange}
          onOrientationChange={onOrientationChange}
        />
      </div>

      <div className="mp-media-picker-modal__body">
        <MediaGrid
          items={items}
          loading={loading}
          error={error}
          selectedId={selectedItem?.id}
          onSelect={onSelect}
          hasMore={hasMore}
          onLoadMore={onLoadMore}
        />
      </div>

      <div className="mp-media-picker-modal__footer">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancelar</button>
        <button type="button" className="btn btn-primary" onClick={onApply} disabled={!selectedItem}>Aplicar</button>
      </div>
    </div>
  );
}
